module.exports = __webpack_public_path__ + "static/img/boiler.f3e2dc2.png";


//////////////////
// WEBPACK FOOTER
// ./img/project-design/boiler.png
// module id = 1021
// module chunks = 1